<template>
  <div :class="['overComponent', { inApp: $root.$data.isApp || this.$root.miniprogram }]">
    <CommonTitle :titleName="title[activityStatus] || '拉新活动'" />
    <div class="tips">
      <template v-if="activityStatus === 9001">
        <img src="../../../assets/img/pullNew/noStart.png" alt="">
        <h4>活动还未开始</h4>
      </template>
      <template v-if="activityStatus === 9002">
        <img src="../../../assets/img/pullNew/over.png" alt="">
        <h4>活动已经结束，下次早点来哦～</h4>
      </template>
      <template v-if="activityStatus === 9408">
        <img src="../../../assets/img/pullNew/over.png" alt="">
        <h4>活动已关闭或奖品已全部领完</h4>
      </template>
      <p>更多免费图书/课程快去看看吧~</p>
    </div>
    <Recommend :activityId="activityId" />
    <AppDown v-if="!(this.$root.ytMini||this.$root.pullNewType===2)" />
  </div>
</template>
<script>
import CommonTitle from '@/components/header/CommonTitle.vue';
import Recommend from '../components/recommends.vue';
import AppDown from '../components/appDown.vue';

export default {
  data() {
    return {
      activityStatus: null,
      activityId: null,
      title: {
        9001: '活动未开始',
        9002: '活动已结束',
        9408: '活动已关闭',
      },
    };
  },
  components: {
    CommonTitle,
    Recommend,
    AppDown,
  },
  created() {
    const { activityStatus, activityId } = this.$route.query;
    this.activityStatus = +activityStatus;
    this.activityId = activityId;
  },
};
</script>
<style scoped lang="scss">
.overComponent {
  min-height: 100vh;
  padding: 100px 0 200px;
  background: #fff;

  &.inApp {
    padding-top: 0;
  }

  .tips {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin: 48px 0;

    img {
      width: 400px;
    }

    h4 {
      font-size: 40px;
      line-height: 70px;
    }

    p {
      color: #999;
      font-size: 28px;
      line-height: 40px;
    }
  }
}
</style>
